/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_CatInputs */

const en_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const ar_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#محادثة`)
};

const bn_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const de_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const es_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const fr_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const pt_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const zh_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const tr_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const ru_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

const pl_svc_messaging_bots_cat = /** @type {(inputs: Svc_Messaging_Bots_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CHAT`)
};

/**
* | output |
* | --- |
* | "#CHAT" |
*
* @param {Svc_Messaging_Bots_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_cat = /** @type {((inputs?: Svc_Messaging_Bots_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_cat(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_cat(inputs)
	if (locale === "de") return de_svc_messaging_bots_cat(inputs)
	if (locale === "es") return es_svc_messaging_bots_cat(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_cat(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_cat(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_cat(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_cat(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_cat(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_cat(inputs)
	return en_svc_messaging_bots_cat(inputs)
});
export { svc_messaging_bots_cat as "svc_messaging-bots_cat" }